import { ThunkAction } from 'redux-thunk';
import { StoreState } from '..';
import { CategoriesAction, CategoriesActionTypes } from './categoriesTypes';
import apiRest from '../../services/apiRest';
import errorHandler from '../../errorHandler';
import { Action } from 'redux';
import { addSnackbar } from '../snacks/snacksActions';

export function getCategories():
ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({
        type: CategoriesActionTypes.GET_CATEGORIES_START,
      });
      const { data } = await apiRest({
        method: 'get',
        url: `/transactions/categories/`,
        params: {
          churchId,
        },
      });
      dispatch({
        type: CategoriesActionTypes.GET_CATEGORIES_SUCCESS,
        categories: data,
      });
    } catch (e) {
      errorHandler(e);
      dispatch( addSnackbar('Houve um problema. Tente mais tarde.', { variant: 'error'}) );
      dispatch({ type: CategoriesActionTypes.GET_CATEGORIES_ERROR });
    }
  };
}

export function saveCategory(form: any):
ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { categories, selectedIndex } = getState().categoriesState;
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }

      dispatch({ type: CategoriesActionTypes.SAVE_CATEGORY_START });

      const categoryOrig = selectedIndex !== null && categories[selectedIndex];

      const res = await apiRest({
        method: categoryOrig ? 'PUT' : 'POST',
        url: `transactions/categories/${categoryOrig ? categoryOrig.id : ''}`,
        params: { churchId },
        data: form,
        validateStatus: status => [200, 201, 409].includes(status),
      });
      if (res.status === 409) {
        dispatch( addSnackbar('Não foi possível salvar pois já existe uma categoria com este nome', { variant: 'error'}) );
        dispatch({ type: CategoriesActionTypes.SAVE_CATEGORY_SUCCESS });
        return;
      }

      dispatch({ type: CategoriesActionTypes.SAVE_CATEGORY_SUCCESS });
      dispatch( addSnackbar('Registro salvo com sucesso', { variant: 'success' }) );
      dispatch( getCategories() );
    } catch (e) {
      errorHandler(e);
      dispatch( addSnackbar('Houve um problema. Tente mais tarde.', { variant: 'error'}) );
      dispatch({ type: CategoriesActionTypes.SAVE_CATEGORY_ERROR });
    }
  };
}

export function removeCategory():
ThunkAction<Promise<void>, StoreState, undefined, Action> {
  return async (dispatch, getState) => {
    try {
      const { selectedIndex, categories } = getState().categoriesState;
      const { selectedChurchIndex, user } = getState().sessionState;
      const churchId = user?.churches?.[selectedChurchIndex]?.id;
      if (!churchId) {
        throw new Error();
      }
      dispatch({ type: CategoriesActionTypes.REMOVE_CATEGORY_START });

      const categoryOrig = selectedIndex !== null && categories[selectedIndex];
      if (!categoryOrig) {
        throw new Error();
      }

      const res = await apiRest({
        method: 'DELETE',
        url: `transactions/categories/${categoryOrig.id}`,
        params: { churchId },
        validateStatus: status => [200, 422].includes(status),
      });
      if (res.status === 422) {
        dispatch( addSnackbar('Não foi possível excluir pois este cadastro possui transações financeiras vinculadas.', { variant: 'error'}) );
        dispatch({ type: CategoriesActionTypes.REMOVE_CATEGORY_SUCCESS });
        return;
      }
      dispatch({ type: CategoriesActionTypes.REMOVE_CATEGORY_SUCCESS });
      dispatch( addSnackbar('Registro removido com sucesso', { variant: 'success' }) );
      dispatch( getCategories() );
    } catch (e) {
      errorHandler(e);
      dispatch( addSnackbar('Houve um problema. Tente mais tarde.', { variant: 'error'}) );
      dispatch({ type: CategoriesActionTypes.REMOVE_CATEGORY_ERROR });
    }
  };
}

export function editingStart(selectedIndex?: number): CategoriesAction {
  return {
    type: CategoriesActionTypes.EDITING_START,
    index: selectedIndex,
  };
}
